import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-hexagon-button-text-icon',
    templateUrl: './hexagon-button-text-icon.component.html',
    styleUrls: ['./hexagon-button-text-icon.component.css'],
    standalone: false
})
export class HexagonButtonTextIconComponent implements OnInit {
    constructor() { }

    @Input()
    public text: string;

    @Input()
    public icon: string;

    @Input()
    public width: number = 2;

    ngOnInit() { }
}
